
import { ComputedRef, onMounted, Ref, ref } from "vue";
import router from "../../../../../src/routes";
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";
import { User } from "../../../../../domain/entities/entities";
import { useRoute } from "vue-router";
import { dispatchErrorBox, formattedDate } from "../../mixins";
import { Receipt } from "../../../../../domain/entities/shop/order/receipt";
import { Product } from "../../../../../domain/entities/shop/product/product";
import { RepositoryException } from "../../../../../domain/exceptions/exceptions";
import HoverGallery from "./HoverGallery.vue";

export default {
  name: "receiptModal",
  components: { HoverGallery },

  setup() {
    const store = useStore();
    const route = useRoute();

    /** Variable get the order id by route.*/
    const orderID = Number(route.params.orderID);

    /** Variable that controls the opening and closing of the modal. */
    const modalOpened: Ref<boolean> = ref(true);

    /** Getter containing the receipt data. */
    const receipt: ComputedRef<Receipt> = computed(() => {
      return store.getters["shop_module/currentReceipt"];
    });

    /** Variable to get the user data. */
    const user: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    const email: Ref<string> = ref("");

    onMounted(async () => {
      try {
        await loadInformation();
        await store.dispatch("shop_module/getReceipt", orderID);
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    });

    /** Function triggered when the modal closes.
     * When the modal is closed, all products are removed from the cart and the order id is removed from the route. */
    async function close(): Promise<void> {
      try {
        await store.dispatch("shop_module/removeAllProductsFromBag");
        modalOpened.value = !modalOpened.value;
        if (modalOpened.value === false) {
          await router.push({
            name: "shop"
          });
        }
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    /** Function responsible for formatting the decoins to Brazilian currency. */
    function formatDecoins(decoins: number) {
      return Intl.NumberFormat("pt-br").format(decoins);
    }

    /** Function that returns the product value according to the amount of products added.*/
    function amount(product: Product): string {
      const amount = product.decoins * product.quantity;
      return formatDecoins(amount);
    }

    const loadInformation = (): void => {
      switch (process.env.VUE_APP_THEME) {
        case "circulo":
          email.value = "sac.circulo@circulo.com.br";
          break;
        case "construcolor":
          email.value = "midia@construcolor.com.br";
          break;
        default:
          email.value = "decola@lince.com.br";
      }
    };
    return {
      modalOpened,
      receipt,
      user,
      email,
      close,
      formattedDate,
      amount
    };
  }
};
